
function pageHeaderSliderV2Override(slider)  {
  return(
    {
      slidesPerView: 1,

      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        // dynamicBullets: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        transitionStart: function () {
          var videos = slider.querySelectorAll('.js_page_header_slider_video');

          Array.prototype.forEach.call(videos, function (video) {
            video.pause();
          });

        },


        transitionEnd: function () {
          var activeIndex = this.activeIndex;
          var activeSlide = slider.querySelectorAll('.js_page_header_slider_v2 .swiper-slide')[activeIndex];
          var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
          if (activeSlideVideo) {
            activeSlideVideo.play();
          }
        },
      }
    }
  )

};
window.pageHeaderSliderV2Override = pageHeaderSliderV2Override;

